<div class="segmented" role="radiogroup" [attr.aria-labelledby]="labelledBy" [attr.aria-describedby]="describedBy"
  [class.segmented--disabled]="disabled">
  @for (option of options; track option.value; let i = $index) {
    <button #segment type="button" role="radio" class="segmented__option"
      [class.segmented__option--active]="option.value === value"
      [attr.aria-checked]="option.value === value"
      [attr.tabindex]="i === activeIndex ? 0 : -1"
      [disabled]="disabled"
      (click)="select(option)" (keydown)="onKeydown($event, i)" (blur)="onBlur()">
      @if (option.value === value) {
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      }
      {{ option.label }}
    </button>
  }
</div>
